export default __webpack_public_path__ + "static/media/CS_196.571109df.png";